import "../../../assets/presentation/components/home/home-D7GT6nmz.css";
import { getPosts } from "../../../redux/posts/thunks/get-posts.js";
import { useHomeDispatch, useHomeSelector } from "../../../redux/config.js";
import { selectArePostsPending, selectPosts, selectPostsErrorMessage } from "../../../redux/posts/selectors.js";
import { useHome } from "../../hooks/use-home.js";
import { EXAMPLE_DIALOG_KEY } from "../example-dialog/example-dialog2.js";
/* empty css     */
import { Article, Button, ButtonLabel, ButtonPriority, Conditional, Main, ViewPort, isEmpty, useBuild, useCountry, useModalView } from "@vana/core";
import { useTranslation } from "react-i18next";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/home/home.tsx
var Home = () => {
	const { t } = useTranslation("home");
	const { count, increment, decrement } = useHome();
	const dispatch = useHomeDispatch();
	const posts = useHomeSelector(selectPosts());
	const arePostsPending = useHomeSelector(selectArePostsPending());
	const postsErrorMessage = useHomeSelector(selectPostsErrorMessage());
	const build = useBuild();
	const [country, countryCode] = useCountry();
	const [revealModalView] = useModalView();
	const loadPosts = () => {
		dispatch(getPosts());
	};
	const openExampleDialog = () => {
		revealModalView({ component: EXAMPLE_DIALOG_KEY });
	};
	return /* @__PURE__ */ jsx(ViewPort, {
		className: "home",
		children: /* @__PURE__ */ jsx(Main, { children: /* @__PURE__ */ jsxs(Article, {
			className: "p-24",
			children: [
				/* @__PURE__ */ jsx("header", {
					className: "home-header",
					children: /* @__PURE__ */ jsx("h1", {
						className: "home-title text-heading-24-bold",
						children: t("title")
					})
				}),
				/* @__PURE__ */ jsx("p", {
					className: "home-counter-count",
					children: count
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "home-actions",
					children: [/* @__PURE__ */ jsx(Button, {
						priority: ButtonPriority.PRIMARY,
						onClick: increment,
						fullHeight: true,
						maxRounded: true,
						children: /* @__PURE__ */ jsx(ButtonLabel, { children: t("increment_action") })
					}), /* @__PURE__ */ jsx(Button, {
						priority: ButtonPriority.SECONDARY,
						onClick: decrement,
						fullHeight: true,
						maxRounded: true,
						children: /* @__PURE__ */ jsx(ButtonLabel, { children: t("decrement_action") })
					})]
				}),
				/* @__PURE__ */ jsxs("section", {
					className: "home-posts",
					children: [
						/* @__PURE__ */ jsx("h2", {
							className: "home-posts-title text-heading-16-bold",
							children: t("posts_title")
						}),
						/* @__PURE__ */ jsx("div", {
							className: "home-actions",
							children: /* @__PURE__ */ jsx(Button, {
								priority: ButtonPriority.PRIMARY,
								onClick: loadPosts,
								isPending: arePostsPending,
								fullHeight: true,
								maxRounded: true,
								children: /* @__PURE__ */ jsx(ButtonLabel, { children: t("load_posts_action") })
							})
						}),
						/* @__PURE__ */ jsx(Conditional, {
							condition: !isEmpty(postsErrorMessage),
							children: /* @__PURE__ */ jsx("p", {
								className: "home-posts-error",
								children: postsErrorMessage
							})
						}),
						/* @__PURE__ */ jsx("ul", {
							className: "home-posts-list",
							children: posts.map((post) => /* @__PURE__ */ jsxs("li", { children: [/* @__PURE__ */ jsx("span", {
								className: "home-posts-user",
								children: `#${post.userId}`
							}), /* @__PURE__ */ jsx("span", {
								className: "home-posts-post-title",
								children: post.title
							})] }, post.id))
						})
					]
				}),
				/* @__PURE__ */ jsxs("section", {
					className: "home-build",
					children: [
						/* @__PURE__ */ jsx("h2", {
							className: "home-build-title text-heading-16-bold",
							children: t("build_title")
						}),
						/* @__PURE__ */ jsx(Conditional, {
							condition: !!build,
							children: /* @__PURE__ */ jsx("p", {
								className: "home-build-value",
								children: build?.environmentType
							})
						}),
						/* @__PURE__ */ jsx(Conditional, {
							condition: !!country,
							children: /* @__PURE__ */ jsx("p", {
								className: "home-build-value",
								children: countryCode
							})
						})
					]
				}),
				/* @__PURE__ */ jsxs("section", {
					className: "home-modal",
					children: [/* @__PURE__ */ jsx("h2", {
						className: "home-modal-title text-heading-16-bold",
						children: t("modal_title")
					}), /* @__PURE__ */ jsx("div", {
						className: "home-actions",
						children: /* @__PURE__ */ jsx(Button, {
							priority: ButtonPriority.PRIMARY,
							onClick: openExampleDialog,
							fullHeight: true,
							maxRounded: true,
							children: /* @__PURE__ */ jsx(ButtonLabel, { children: t("open_modal_action") })
						})
					})]
				})
			]
		}) })
	});
};
//#endregion
export { Home };

//# sourceMappingURL=home2.js.map